export type CreatorReportStatus = 'pending' | 'completed' | 'failed'

export type CreatorReportRaw = {
  uuid: string
  status: CreatorReportStatus
  created_by: number
  created_at: string
}

export type CreatorReportItem = {
  uuid: string
  status: CreatorReportStatus
  createdBy: number
  createdAt: string
}

export const normalizeCreatorReports = (data: CreatorReportRaw[]): CreatorReportItem[] =>
  data.map((item) => ({
    uuid: item.uuid,
    status: item.status,
    createdBy: item.created_by,
    createdAt: item.created_at,
  }))
